import { type PropsWithChildren, Suspense } from 'react'

import { Loading } from './Loading'

export const SubAppLoading = () => {
  return (
    <div className="shipper-page-fill flex items-center justify-center p-56">
      <Loading />
    </div>
  )
}

export const SubAppSuspense = ({ children }: PropsWithChildren) => {
  return <Suspense fallback={<SubAppLoading />}>{children}</Suspense>
}
